/**
 * @internal
 */
import { useUpdateEffect } from '@polestar/component-warehouse-react/hooks/useUpdateEffect';
// provide access about when the OptionsList is closed or opened
const useOptionsListToggled = (visible, callback) => {
    useUpdateEffect(() => {
        callback === null || callback === void 0 ? void 0 : callback(visible);
    }, [visible]);
};
export default useOptionsListToggled;
